import { useState, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import Zoom from 'react-reveal/Zoom';
import aboutImage from '../../../assets/img/about-pic.jpg';
import aboutTransformationPic from '../../../assets/img/about-transformation-pic.png';
import aboutShowPic1 from '../../../assets/img/about-show-pic1.png';
import aboutShowPic2 from '../../../assets/img/about-show-pic2.jpeg';
import nasmLogo from '../../../assets/img/nasm-logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuoteLeft, faDumbbell, faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import './AboutSection.css';

function AboutSection() {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 991);

    const updateIsDesktop = () => {
        setIsDesktop(window.innerWidth > 576);
    };

    useEffect(() => {
        window.addEventListener("resize", updateIsDesktop);
        return () => {
            window.removeEventListener("resize", updateIsDesktop);
        }
    });

    return (
        <div id="about-section">
            <Container fluid>
                <Row className="align-items-center" id="about-intro-row">
                    <Col className="about-col" md={6}>
                        <img id="about-pic" src={aboutImage} width="80%" alt="Profile"></img>
                    </Col>
                    <Col className="about-col" md={6}>
                        <Zoom>
                            <div id="aboutHeadingQuoteOuter">
                                {isDesktop ? 
                                (<div id="quoteIconOuter">
                                    <FontAwesomeIcon icon={faQuoteLeft} size="2x" color="#708090" />
                                </div>) : null}
                                <div id="aboutHeadingOuter">
                                    <h2 id="about-heading">Hey! My name is Daniel Morales.</h2>
                                </div>
                            </div>
                            <p className="about-paragraph">I am an SNBF Men’s Physique Pro Bodybuilder, Personal Trainer, Group Fitness Instructor, and Online Fitness Coach.</p>
                            <p className="about-paragraph">In 2016, I started my personal transformation through health and wellness. Starting out at 225lbs I was tired of being overweight and unhealthy. I started by losing 50lbs in 1 year then the rest was history. I became a NASM Certified Personal Trainer in 2018 and started sharing my story with others with the goal of helping them take control of their health and wellness.</p>
                            <p className="about-paragraph">My passion for coaching others with their health and wellness led me to growing an online coaching platform where I am able to work with people who I am not able to interact with in person.</p>
                        </Zoom>
                    </Col>
                </Row>
                <Row id="journey-row">
                    <Col lg={12} id="journey-row-title">
                        <Zoom>
                            <h2 id="journey-title">JOURNEY</h2>
                        </Zoom>
                    </Col>
                    <Col className="about-col" sm={4}>
                        <Zoom delay={isDesktop ? 500 : null}>
                            <div>
                                <div className="journey-icon">
                                    <FontAwesomeIcon icon={faDumbbell} size="3x" color="grey" />
                                </div>
                                <span className="journey-heading">50lb Weight Loss Transformation</span>
                                <span className="journey-subheading">2016</span>
                            </div>
                        </Zoom>
                    </Col>
                    <Col className="about-col" sm={4}>
                        <Zoom delay={isDesktop ? 1000 : null}>
                            <div>
                                <div className="journey-icon">
                                    <img id="nasm-img" src={nasmLogo} alt="NASM Logo" width="100"></img>
                                </div>
                                <span className="journey-heading">Received NASM Personal Trainer Certification - Became a Personal Trainer, Group Fitness Instructor, & Online Coach</span>
                                <span className="journey-subheading">2018</span>
                            </div>
                        </Zoom>
                    </Col>
                    <Col className="about-col" sm={4}>
                        <Zoom delay={isDesktop ? 1500 : null}>
                            <div>
                                <div className="journey-icon">
                                    <FontAwesomeIcon icon={faGraduationCap} size="3x" color="red" />
                                </div>
                                <span className="journey-heading">SNBF Natural Men’s Physique Pro & 4 x 1st Place Men’s Physique Competitor</span>
                                <span className="journey-subheading">2021</span>
                            </div>
                        </Zoom>
                    </Col>
                </Row>
                <Row id="transformation-heading-row" className="transformation-row">
                    <Col className="about-col" md={{ span: 8, offset: 2 }} offset={4}>
                        <Zoom>
                            <h2 id="transformation-heading">MY TRANSFORMATION</h2>
                        </Zoom>
                    </Col>
                </Row>
                <Row className="transformation-row">
                    <Col className="about-col" md={{ span: 8, offset: 2 }} offset={4}>
                        <Zoom>
                            <img id="about-transformation-pic" src={aboutTransformationPic} width="80%" alt="Transformation"></img>
                        </Zoom>
                    </Col>
                </Row>
                <Row id="transformation-paragraph-row" className="transformation-row">
                    <Col className="about-col" md={{ span: 8, offset: 2 }} offset={4}>
                        <p id="transformation-paragraph">In 2016, I was getting ready to graduate high school, walking around at 230 pounds, completely unhappy with the way I felt, looked, and carrying a low self-esteem. I decided to make a change. I took control of the variables I had power over. Those being my nutrition, my activity level, and my mindset towards self-love and taking care of the one body I was given. From that moment on, I dedicated myself to improving and learning about how to live a healthier lifestyle. It started with sticking to a consistent workout program, then moved to correcting my bad eating habits. As time passed, results started coming slowly and I started to develop a passion for my training and nutrition. During the last 5 years, I became emotionally and mentally stronger. My passion for health and wellness has opened many doors, and I can surely say that I am nowhere close to being done with my journey of inspiring and motivating others to embark on their own.</p>
                    </Col>
                </Row>
                <Row id="transformation-pics-row" className="transformation-row">
                    <Col className="about-col" md={6}>
                        <Zoom>
                            <img id="about-show-pic1" src={aboutShowPic1} width="80%" alt="Show Posing"></img>
                        </Zoom>
                    </Col>
                    <Col className="about-col" md={6}>
                        <Zoom>
                            <img id="about-show-pic2" src={aboutShowPic2} width="80%" alt="Show Trophy"></img>
                        </Zoom>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default AboutSection;